import { useEffect, useState } from "react";
import { Spinner } from "@heroui/react";
import { useThemeStore, loadLogoBase64, getLogoBase64 } from "../utils/themeManager";

/**
 * Le o valor efetivo de `env(safe-area-inset-bottom)` aplicando-o num elemento
 * de sondagem e lendo o estilo computado -- nao existe API direta para isso.
 *
 * DIAGNOSTICO TEMPORARIO: existe so para confirmar, num aparelho com barra de 3
 * botoes, se a WebView do Android reporta o inset (o suporte a env() em WebView
 * e inconsistente). Remover junto com o `<span>` da splash quando o diagnostico
 * fechar.
 */
function medirInsetInferior(): string {
  try {
    const probe = document.createElement("div");
    probe.style.position = "fixed";
    probe.style.visibility = "hidden";
    probe.style.paddingBottom = "env(safe-area-inset-bottom)";
    document.body.appendChild(probe);
    const valor = getComputedStyle(probe).paddingBottom;
    probe.remove();
    return valor || "?";
  } catch {
    return "erro";
  }
}

export function SplashScreen() {
  const theme = useThemeStore(state => state.theme);
  const [inset, setInset] = useState("");

  useEffect(() => {
    loadLogoBase64();
    setInset(medirInsetInferior());
  }, []);

  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center"
         style={{backgroundColor: theme.primaryColor}}
    >
      <img
        src={getLogoBase64()}
        alt="PlayBPO"
        className="h-16 mb-6"
      />
      <Spinner style={{color: theme.secondaryColor}} size="lg" />
      <span style={{ color: theme.secondaryColor, opacity: 0.6 }} className="absolute bottom-6 text-xs">
        v.2.0.4{inset ? ` · inset ${inset}` : ""}
      </span>
    </div>
  );
}
